import api from "./services/mkm.api.js"

const resource = "/gemeinde"

export default{
    alle() {
        return api.get(`${resource}`);
    }
}